<template>
  <div class="navStyle">
    <Row class="mp_navStyle" type="flex">
      <i-col span="12" class="mp_navStyle_title">
        <router-link to="/"
          ><img src="static/image/icon-logo.png" class="imgStyle"
        /></router-link>
        <Divider type="vertical" />
        <router-link to="/"
          ><div class="navStyle_subtitle">
            人人都是数据分析师
          </div></router-link
        >
      </i-col>
      <i-col span="12" class="mp_navStyle_title_right">
        <router-link to="/aboutUs"
          ><Button type="primary" shape="circle" ghost
            >关于我们</Button
          ></router-link
        >
        <div class="btn_down">
          <router-link to="/download">
            <Button type="primary" shape="circle">免费下载</Button>
          </router-link>
        </div>
        <router-link to="/notice">
          <Badge text="公告">
            <Icon type="ios-notifications-outline" class="noticeStyle"></Icon>
          </Badge>
        </router-link>
        <div
          v-if="isObjectNull(userMsg)"
          class="mp_navStyle_title_right_login"
          @click="reg"
        >
          注册
        </div>
        <div
          v-if="isObjectNull(userMsg)"
          class="mp_navStyle_title_right_login"
          @click="login"
        >
          登录
        </div>
        <div
          v-if="!isObjectNull(userMsg)"
          class="mp_navStyle_title_right_login"
        >
          <Dropdown trigger="hover" @on-click="clickItem">
            <a href="javascript:void(0)">
              <Icon type="md-contact" class="iconStyle" />
            </a>
            <DropdownMenu slot="list">
              <DropdownItem name="setting"
                ><router-link to="/setting" class="lineStyle"
                  >账号设置</router-link
                ></DropdownItem
              >
              <DropdownItem name="exitSys"
                ><span class="lineStyle">退出登录</span></DropdownItem
              >
            </DropdownMenu>
          </Dropdown>
        </div>
      </i-col>
    </Row>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    activeName: {
      get() {
        return this.$store.state.activeName;
      },
      set(activeName) {
        this.$store.dispatch("commitActiveName", activeName);
      }
    },
    isShow: {
      get() {
        return this.$store.state.isShow;
      },
      set(isShow) {
        this.$store.dispatch("commitIsShow", isShow);
      }
    },
    userMsg: {
      get() {
        return this.$store.state.userMsg;
      },
      set(userMsg) {
        this.$store.dispatch("commitUserMsg", userMsg);
      }
    }
  },
  methods: {
    clickItem(name) {
      switch (name) {
        case "exitSys":
          this.deleteLogout();
          break;
        default:
          break;
      }
    },
    //退出登录
    deleteLogout() {
      this.$axios.deleteLogout().then(() => {
        this.$store.dispatch("commitUserMsg", {});
        if (this.$route.path === "/setting") {
          this.$router.replace({ path: "/" });
        }
      });
    },
    isObjectNull(data) {
      return JSON.stringify(data) === "{}";
    },
    reg() {
      this.activeName = "reg";
      this.isShow = true;
    },
    login() {
      this.activeName = "login";
      this.isShow = true;
    }
  }
};
</script>
<style lang="less" scoped>
.noticeStyle {
  font-size: 28px;
  padding-left: 10px;
}
@media screen and (min-width: 568px) {
  .navStyle {
    padding: 0 55px;
  }
  .mp_navStyle_title {
    float: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .navStyle_subtitle {
    font-size: 16px;
    font-weight: bold;
    font-family: "微软雅黑";
    letter-spacing: 2px;
    color: #545454;
  }
}
@media screen and (max-width: 568px) {
  .navStyle {
    padding: 0 40px;
  }
  .mp_navStyle_title {
    float: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .navStyle_subtitle {
    font-size: 14px;
    font-weight: bold;
    font-family: "微软雅黑";
    letter-spacing: 1px;
    color: #545454;
  }
}
.lineStyle {
  color: inherit;
}
.lineStyle:hover {
  color: #2d8cf0;
}
.navStyle {
  z-index: 2;
  box-shadow: 0 1px 3px rgba(26, 26, 26, 0.1);
  .mp_navStyle {
    height: 80px;
    .btn_down {
      margin-left: 20px;
    }
    .mp_navStyle_title_right {
      float: right;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-right: 5px;
      .mp_navStyle_title_right_login {
        min-width: 50px;
        font-size: 14px;
        text-align: right;
        cursor: pointer;
        .iconStyle {
          font-size: 35px;
          color: #808695;
          opacity: 0.5;
        }
        .iconStyle:hover {
          color: #515a6e;
        }
      }
      .mp_navStyle_title_right_login:hover {
        color: #3091f2;
      }
    }
    .ivu-divider,
    .ivu-divider-vertica {
      height: 35% !important;
    }
    .imgStyle {
      height: 50px;
      margin-bottom: 10px;
    }
    .navStyle_divder {
      display: inline-block;
      width: 1px;
      height: 40%;
      margin: 0 15px;
      vertical-align: middle;
      position: relative;
      background: #e8eaec;
    }
  }
}
</style>
